import { FC } from 'react'
import { useForm } from 'react-hook-form'
import { Modal } from '@/shared/ui/modal'

interface ConfirmModalProps {
    isOpen: boolean
    title: string
    message: string
    confirmText?: string
    onConfirm: () => Promise<void> | void
    onCancel: () => void
}

export const ConfirmModal: FC<ConfirmModalProps> = ({
    isOpen,
    title,
    message,
    confirmText = 'Подтвердить',
    onConfirm,
    onCancel,
}) => {
    const { handleSubmit, formState: { isSubmitting } } = useForm()

    return (
        <Modal isOpen={isOpen} title={title} onRequestClose={onCancel}>
            <form onSubmit={handleSubmit(onConfirm)} className="flex flex-col gap-4">
                <div className="text-sm text-color-dark">{message}</div>
                <div className="flex gap-3">
                    <button type="button" className="form_cancel_button" onClick={onCancel}>
                        Отменить
                    </button>
                    <button type="submit" className="form_handle_button" disabled={isSubmitting}>
                        {isSubmitting ? '...' : confirmText}
                    </button>
                </div>
            </form>
        </Modal>
    )
}
